<template>
  <DetailsAsideLayout>
    <template v-slot:detailsContent>
      <CommandDetailsDetails />
      <CommandDetailsLaunchEvent
        :isRegistrationTrigger="isRegistrationTrigger"
      />
      <CommandDetailsOptions />
      <CommandDetailsFiles />
    </template>
  </DetailsAsideLayout>
</template>

<script>
import DetailsAsideLayout from 'components/AsidePanel/Details/DetailsAsideLayout.vue';

import CommandDetailsDetails from './CommandDetailsDetails.vue';
import CommandDetailsFiles from './CommandDetailsFiles.vue';
import CommandDetailsLaunchEvent from './CommandDetailsLaunchEvent.vue';
import CommandDetailsOptions from './CommandDetailsOptions.vue';

export default {
  name: 'CommandDetails',

  inject: ['$validator'],

  components: {
    CommandDetailsDetails,
    CommandDetailsFiles,
    CommandDetailsLaunchEvent,
    CommandDetailsOptions,
    DetailsAsideLayout,
  },

  props: {
    isRegistrationTrigger: Boolean,
  },
};
</script>
